import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext, useRef } from "react";
import UserContext from "../components/context";
import {
  setDoctorId,
  setDoctorName,
  getVisitTypeName,
  getisFollowupYN,
  getVisitTypeID,
  getPurposeOfVistID,
  getisGlobal,
  postRequest,
  getUser,
  setVisitId,
  getVisitId,
  getCompanyId,
  getMandatoryData,
  setVisitType,
  setExamId,
  setFutureVisitFromSMDashboard,
  setLanguageId,
  getCompanyName,
  getDoctorId,

} from "../Services/DataMode";
import ReactLoading from "react-loading";
import React from "react";
import VisitsList from "../components/VisitsList";
import Reschedule from "./Reschedule";
import PreviousVisitDetails from "./PreviousVisitDetails";
import { format } from "date-fns";
import CompanyChangeView from "../components/ChangeCompanyView";
import ReasonForCancel from "../components/ReasonForCancel";

// import Rating from "./Rating";
function PrivateDashboard(props) {
  const [modalShowPopUP, setModalShowPopUP] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalShow2, setModalShow2] = React.useState(false);
  const [modalShow3, setModalShow3] = React.useState(false);
  const [visits, setVisits] = useState([]);
  const [loading, setloading] = useState(true);
  const userInfo = useContext(UserContext).user;
  const context = useContext(UserContext);
  let navigate = useNavigate();
  const [useVisit, setUseVisit] = useState([]);
  const [reloading, setreloading] = useState(false);
  const [date, setDate] = useState(new Date());
  const ref = useRef();
  const [reasons, setReasons] = React.useState([]);
  const [selectedReason, setSelectedReason] = useState(0);
  const [subReasonList, setSubReasonsList] = useState([]);
  const [getData, setGetData] = useState(false);
  const [subreason, setSubreason] = useState("0");
  const [enteredComments, setEnteredComments] = useState("");
  const [comments, setComments] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState(false);
  const [visible, setVisibility] = useState(false);
  const [showReasonMandatory, setShowReasonMandatory] = useState(false);
  const [showPatientsReasonMandatory, setShowPatientsReasonMandatory,] = useState(false);
  const [showCommentsMandatory, setShowCommentsMandatory] = useState(false);

  useEffect(() => {
    props.updatePage();
    loadDashboard();
    setVisitId(0);
    setVisitType("");
    setExamId("");
  }, [reloading]);

  function loadDashboard() {
    setloading(true);
    // console.log("getisGlobal");
    // console.log(getisGlobal());
    // console.log("getisGlobal")
    postRequest(
      "ws_webrtc/Util.asmx/getSelfPayDashboardVisits",
      {
        sKey: getUser(),
        sPatientName: "",
        //iPurposeOfVisit: getPurposeOfVistID(),
        bFollowup: getisFollowupYN(),
        iVisitCatergory: getVisitTypeID(),
      },
      (response) => {
        // console.log(response);
        setloading(false);
        setVisits(response.d);
      },
      context
    );
  }

  function resetReasonAlertData() {
    setSelectedReason(0);
    setVisibility(false);
    setSubreason("0");
    setRescheduleDate(false);
    setComments(false);
    setModalShow3(false);
  }

  function visitDeleteClicked(item) {
    if (item.followup_YN) {
      // console.log("visit clicked item", item.followup_YN); // true
      reasonsforCancel();
      setModalShow3(true);
      setUseVisit(item);
    }
    else {
      var str = "Do you want to cancel the visit for patient <XXXXXXXXX>  ?";
      var new_str = str.replace(/<XXXXXXXXX>/g, item.first_name + " " + item.last_name);

      var array = ["Do you want to cancel the visit for patient ", item.first_name + " " + item.last_name, " ?",];
      context.setUser(1, "Info", array, "Yes", true, "No", () => { console.log(false); },
        () => {
          deleteVisit(item.visit_id, item.first_name, item.last_name, "0", "0", " ");
        }
      );
    }
  }

  function deletewithReason(item) {
    if (selectedReason == 0) {
      context.setUser(0, "Error", getMandatoryData("sm_dashboard", "reasonForCancelMandatory"), "OK"
      );
    }
    else if (selectedReason == 1) {
      if (subreason == 0) {
        context.setUser(0, "Error", getMandatoryData("sm_dashboard", "reasonForCancelSubMandatory"), "OK");
      }
      else if (subreason == 4) {
        if (enteredComments == "" && getMandatoryData("sm_dashboard", "reasonForCancelCommentsMandatory") !== "") {
          context.setUser(0, "Error", getMandatoryData("sm_dashboard", "reasonForCancelCommentsMandatory"), "OK");
        }
        else {
          deleteVisit(
            useVisit.visit_id,
            useVisit.first_name,
            useVisit.last_name,
            selectedReason,
            subreason,
            enteredComments
          );
          setModalShow3(false);
          setSelectedReason(0);
          setSubReasonsList("");
          setRescheduleDate(false);
          setComments(false);
        }
      }
      else {
        // submit delete
        deleteVisit(
          useVisit.visit_id,
          useVisit.first_name,
          useVisit.last_name,
          selectedReason,
          subreason,
          ""
        );
        setModalShow3(false);
        setSelectedReason(0);
        setSubReasonsList("");
        setRescheduleDate(false);
        setVisibility(false);
        setSubreason("0");
      }
    }
    else if (selectedReason == 2) {
      // console.log(subReasonList, "subreasonlist");
      // console.log(date);
      var finalDate = format(date, 'yyyy-MM-dd');
      // console.log(finalDate);
      RescheduleVisit(useVisit, selectedReason, "0", "", finalDate);
      setModalShow3(false);
      setSelectedReason(0);
      setSubReasonsList("");
      setRescheduleDate(false);
    }
    else if (selectedReason == 3) {
      if (enteredComments == "" && getMandatoryData("sm_dashboard", "reasonForCancelCommentsMandatory") !== "") {
        context.setUser(0, "Error", getMandatoryData("sm_dashboard", "reasonForCancelCommentsMandatory"), "OK");
      }
      else {
        // submit delete
        deleteVisit(
          useVisit.visit_id,
          useVisit.first_name,
          useVisit.last_name,
          selectedReason,
          "0",
          enteredComments
        );
        setModalShow3(false);
        setSelectedReason(0);
        setSubReasonsList("");
        setRescheduleDate(false);
        setComments(false);
      }
    }
  }

  function reasonsforCancel() {
    postRequest(
      "ws_webrtc/Telemed.asmx/VisitCancelReasonType",
      { sKey: getUser() },
      (response) => {
        // console.log("reasons response type", response.d);
        // console.log("reasons response type", response.d);
        var newArray = [];
        newArray.push({ id: 0, name: "Select" });
        for (var i = 0; i < response.d.length; i++) {
          newArray.push({
            id: response.d[i].reason_type_id,
            name: response.d[i].reason_type,
          });
        }
        // console.log("setReasons", newArray);
        setReasons(newArray);
        /// console.log("setReasons",reasons);
      },
      context
    );
  }

  function handleFieldReasonChange(event) {
    var Array = [];
    var name = event.target.name;
    var value = event.target.value;
    setSelectedReason(event.target.value);
    // console.log(event.target.name + " --> " + event.target.value);
    // console.log(event.target + " -----> ");
    // console.log(selectedReason + "selectedReason -----> ");
    if (value == 1) {
      // setVisibility(true)
      setComments(false);
      subreasonsforCancel(value);
      setRescheduleDate(false);
    }
    else if (value == 3) {
      setVisibility(false);
      setSubreason("0");
      setComments(true);
      setRescheduleDate(false);
    }
    else if (value == 2) {
      setComments(false);
      setVisibility(false);
      setSubreason("0");
      setRescheduleDate(true);
      // console.log("set DAte picker");
    }
    else {
      setRescheduleDate(false);
      setVisibility(false);
      setSubreason("0");
    }
  }

  function onFieldChange(event) {
    var name = event.target.name;
    var value = event.target.value;
    // console.log(event.target.name + " --> " + event.target.value);
    setEnteredComments(event.target.value);
  }

  function subreasonsforCancel(item) {
    postRequest(
      "ws_webrtc/Telemed.asmx/PatientReasonTypeForVisitCancel",
      { sKey: getUser(), iReasonTypeId: item },
      (response) => {
        // console.log("sub reasons response type", response.d);
        if (response.d !== "") {
          var newArray = [];
          newArray.push({ id: 0, name: "Select" });
          for (var i = 0; i < response.d.length; i++) {
            newArray.push({
              id: response.d[i].patient_reason_type_id,
              name: response.d[i].patient_reason_type,
            });
          }
          setSubReasonsList(newArray);
          setVisibility(true);
          // console.log("setsubReasons", newArray);
        }
        else {
          var array = [];
          setSubReasonsList(array);
        }
      },
      context
    );
  }

  function handleFieldChangesubreasons(event) {
    var name = event.target.name;
    var value = event.target.value;
    // console.log(event.target.name + " --> " + event.target.value);
    setSubreason(event.target.value);
    if (value == 4) {
      setComments(true);
    }
  }

  function deleteVisit(visit_id, first_name, last_name, iReasonTypeId, iPatientReasonSubTypeId, comments) {
    setloading(true);
    postRequest(
      "ws_webrtc/Telemed.asmx/DeleteFollowUpVisit_New",
      {
        sKey: getUser(),
        iVisitId: visit_id,
        iReasonTypeId: iReasonTypeId,
        iPatientReasonSubTypeId: iPatientReasonSubTypeId,
        comments: comments,
      },
      (response) => {
        setloading(false);
        var str = "Visit for patient <XXXXXXXXX> cancelled successfully.";
        var new_str = str.replace(/<XXXXXXXXX>/g, first_name + " " + last_name);
        var array = ["Visit for patient ", first_name + " " + last_name, " cancelled successfully."];
        context.setUser(2, "Success", array, "OK");
        setreloading(!reloading);
      },
      context
    );
  }

  function popupClose() {
    setModalShowPopUP(false);
  }

  function popupSubmitClose() {
    setModalShowPopUP(false);
    loadDashboard();
  }

  function onDateChanged(value) {
    // console.log("Dashboard date  ++++> " + value);
    const date = new Date(value);
    // console.log("setdate", date)
    if (!isNaN(date)) {
      setDate(date);
    }
    else {
      // console.log("error", date)
      console.error("Invalid date value:", value);
    }
  }

  function RescheduleVisit(item, iReasonTypeId, iPatientReasonSubTypeId, comments, sFollowUp_Date) {
    //16-10-2024 checking LockPatient_YN
    postRequest(
      "ws_webrtc/Telemed.asmx/getLockPatient_YN",
      { sKey: getUser(), sSSN: item.ssn },
      (response) => {
        if (response.d.status) {
          context.setUser(1, "Info", getMandatoryData("PrivateVisitPage", "isPatientLocked"), "OK", false, "", () => { console.log(false); }, () => {
            navigate("/App/PrivateDashboard");
          }
          );
        }
        else {
          // console.log("Follow-Up Date:", sFollowUp_Date);
          postRequest(
            "ws_webrtc/telemed.asmx/AlterFollowUpDate_New",
            {
              sKey: getUser(),
              iVisitId: item.visit_id,
              sFollowUp_Date: sFollowUp_Date,
              iReasonTypeId: iReasonTypeId,
              iPatientReasonSubTypeId: iPatientReasonSubTypeId,
              comments: comments
            },
            (response) => {
              // console.log("Reschedule", response);
              loadDashboard();
            },
            context
          );
        }
      },
    );
  }

  function CreateInitialLevel(item) {
    // Check if it's a regular visit or follow-up
    if (item.visit_id == 0) {
      setloading(true);
      setVisitType("Regular");
      navigate("/App/PrivateCreateVisit");
    }
    else {
      setloading(true);
      // Send request to create follow-up visit and handle response
      postRequest(
        "ws_webrtc/Util.asmx/FollowUpVisitCreateInitialLevel",
        { sKey: getUser(), iVisitId: item.visit_id },
        (response) => {
          // console.log(response);
          setloading(false);
          // Check if it's a future visit
          if (item.IsFutureVisit && !item.Abort_YN) {
            setVisitId(item.visit_id);
            setVisitType("Future");
            setFutureVisitFromSMDashboard("True");
            navigate("/App/PrivateCreateVisit");
          }
          else {
            // Handle follow-up logic
            if (item.followup_YN == true) {
              if (!response.d.FollowUp_Visit_Create_YN) {
                context.setUser(1, "Info", response.d.message, "OK", false, "No", () => { }, () => { });
              }
              else if (response.d.Patient_Level_YN) {
                context.setUser(1, "Info", response.d.message, "OK", false, "No", () => { }, () => { });
              }
              else {
                setModalShow2(true);
                setUseVisit(item);
              }
            }
            else {
              // Handle regular visit logic
              setLanguageId(item.Language_Id);
              setVisitId(item.visit_id);
              setVisitType("Regular");

              if (item.PurposeOfVisit_Id === 2) {
                if (getDoctorId() === 0) {
                  postRequest(
                    "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
                    { sKey: getUser(), iVisitId: item.visit_id, iDocId: 0 },
                    (response) => {
                      // console.log("doctor_id", response);
                      setDoctorId(0);
                      setDoctorName("Next Available");
                      navigate("/App/PatientCallRoom");
                    },
                    context
                  );
                }
              }
              else {
                if (getMandatoryData("PrivateVisitPage", "isSelectaProviderScreenVisible")) {
                  isproviderEngaged(item);
                }
                else {
                  navigate("/App/SelectProvider");
                }
              }
            }
          }
        },
        context
      );
    }
  }

  function getdocCheckoutStatus() {

    postRequest(
      "ws_webrtc/Telemed.asmx/getStateSpecificProvider",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log("get Doc checkoutResponse2", response.d);
        if ((response.d.IsInCheckout || response.d.IsInConference) && response.d.Doc_ID > 0) {
          context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
            false, "", "", () => {
              navigate("/App/Dashboard");
              notifyEmail();
            }
          );
        }
        else {
          postRequest(
            "ws_webrtc/Telemed.asmx/IsProviderCheckoutState",
            { sKey: getUser(), iVisitId: getVisitId() },
            (checkoutResponse) => {
              // console.log("get Doc checkoutResponse1", checkoutResponse.d);
              if ((checkoutResponse.d.IsInCheckout || checkoutResponse.d.IsInConference) && response.d.Doc_ID > 0) {
                context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
                  false, "", "", () => {
                    navigate("/App/Dashboard");
                    notifyEmail();
                  }
                );
              }
              else {
                insertDoc(response.d.Doc_ID);
                setDoctorId(response.d.Doc_ID);
              }
              // console.log(checkoutResponse, "che")
            }
          );
        }
      }
    );
  }

  function isproviderEngaged(item) {
    postRequest(
      "ws_webrtc/telemed.asmx/IsAllTelemedProvidersEngaged",
      { sKey: getUser(), iVisitId: item.visit_id },
      (response) => {
        // console.log(response.d, "get Doc status");
        if (response.d) {
          context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), "OK", false, "", () => { }, () => {
            notifyEmail();
          });
        }
        else {
          getdocCheckoutStatus(item);
        }
      },
      context
    );
  }

  // function getStateSpecific(item) {
  //   postRequest(
  //     "ws_webrtc/Telemed.asmx/IsProviderCheckoutState",
  //     { sKey: getUser(), iVisitId: getVisitId() },
  //     (checkoutResponse) => {
  //       if ((checkoutResponse.d.IsInCheckout || checkoutResponse.d.IsInConference) && checkoutResponse.d.doc_id > 0) {
  //         context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
  //           false, "", "", () => {
  //             navigate("/App/PrivateDashboard");
  //             notifyEmail();
  //           }
  //         );
  //       } else {
  //         postRequest(
  //           "ws_webrtc/Telemed.asmx/getStateSpecificProvider",
  //           { sKey: getUser(), iVisitId: getVisitId() },
  //           (response) => {
  //             console.log("get Doc check oout status", response.d);
  //             if ((response.d.IsInCheckout || response.d.IsInConference) && response.d.Doc_ID > 0) {
  //               context.setUser(1, "Info", getMandatoryData("select_provider", "all_engaged_message"), getMandatoryData("select_provider", "all_engaged_btn"),
  //                 false, "", "", () => {
  //                   navigate("/App/PrivateDashboard");
  //                   notifyEmail();
  //                 }
  //               );
  //             }
  //             else {
  //               insertDoc(response.d.Doc_ID);
  //               setDoctorId(response.d.Doc_ID);
  //             }
  //           }
  //         );

  //       }

  //     }
  //   );
  // }

  function insertDoc(item) {
    //setLoading(true)
    // console.log(item);
    postRequest(
      "ws_webrtc/Telemed.asmx/InsertProviderForVisitLog",
      { sKey: getUser(), iVisitId: getVisitId(), iDocId: item },
      (response) => {
        setDoctorId(item);
        navigate("/App/PatientCallRoom");
      },
      context
    );
  }

  function PreviousVisitDetailsOKClicked(item) {
    setModalShow2(false);

    // Check if the follow-up visit is due
    if (useVisit.date_of_service === format(new Date(), "MM/dd/yyyy")) {
      setloading(true);
      setVisitId(useVisit.visit_id);
      navigate("/App/PrivateCreateVisit");
    }
    else {
      context.setUser(1, "Info", "Follow Up visit not due as yet - Wish to edit date, click 'Yes'.", "Yes", true, "No", () => {
        // console.log(false);
      },
        () => {
          setVisitId(useVisit.visit_id);
          navigate("/App/PrivateCreateVisit");
        }
      );
    }
  }

  function notifyEmail() {
    postRequest(
      "ws_webrtc/Telemed.asmx/SendEmailToTelemedProviders",
      { sKey: getUser(), iVisitId: getVisitId() },
      (response) => {
        // console.log(response);
      },
      context
    );
  }

  return (
    <div className="h-100 col-12 px-2">
      {/* {loading && <div> <ReactLoading type={'bubbles'} color={'#ff0000'} height={'20%'} width={'20%'}  /> </div>} */}
      {loading && (
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReactLoading
            type={"spin"}
            color={"#ff0000"}
            height={"5%"}
            width={"5%"}
          />
        </div>
      )}

      <div className="px-1">

        <VisitsList
          deleteIcon={true}
          data={visits}
          handleRescheduleClick={(item) => {
            // console.log("reschedule data", item);

            //16-10-2024 checking LockPatient_YN when click on Reschedule button

            postRequest(
              "ws_webrtc/Telemed.asmx/getLockPatient_YN",
              { sKey: getUser(), sSSN: item.ssn },
              (response) => {
                if (response.d.status) {
                  // console.log("lpatient1", response);
                  context.setUser(1, "Info", getMandatoryData("PrivateVisitPage", "isPatientLocked"), "OK", false, "", () => {
                    // console.log(false);
                  }, () => {
                    // navigate("/App/Dashboard");
                  });
                }
                else {
                  setModalShow(true);
                  setUseVisit(item);
                }
              }
            );
          }}
          handleClick={CreateInitialLevel}
          handleDeleteClick={visitDeleteClicked}
        />

        {modalShow && (
          <Reschedule
            show={modalShow}
            onHideMain={() => {
              RescheduleVisit(useVisit, "0", "0", " ", format(date, "yyyy-MM-dd"));
              setModalShow(false);
            }}
            handleDateChange={onDateChanged}
            onHide={() => {
              setDate(new Date());
              setModalShow(false);
            }}
            data={useVisit}
            changedDate={date}
          />
        )}

        {modalShow2 && (
          <PreviousVisitDetails
            show={modalShow2}
            onHideMain={() => setModalShow2(false)}
            onHide={PreviousVisitDetailsOKClicked}
            data={useVisit}
          />
        )}

        {modalShow3 && (
          <ReasonForCancel
            showReasonMandatory={showReasonMandatory}
            showPatientsReasonMandatory={showPatientsReasonMandatory}
            showCommentsMandatory={showCommentsMandatory}
            show={modalShow3}
            onHideMain={(item) => { deletewithReason(item) }}
            onHide={() => resetReasonAlertData()}
            data={useVisit}
            reasons={reasons}
            value={selectedReason}
            handleFieldReason={(event) => handleFieldReasonChange(event)}
            handleFieldChangesubreasons={handleFieldChangesubreasons}
            onFieldChange={onFieldChange}
            patientreason={subReasonList}
            subreasonvalue={subreason}
            comments={comments}
            handleDateChange={onDateChanged}
            changedDate={date}
            rescheduleDate={rescheduleDate}
            setpatientreason={visible}
          />
        )}
      </div>

      {modalShowPopUP && (
        <>
          <CompanyChangeView
            onHide={popupClose}
            onSubmitHide={popupSubmitClose}
          />
        </>
      )}
      {/* <Rating show={modalShow2} onHide={closeClicked} onFieldChange={handleFieldChange} />      */}
    </div>
  );
}

export default PrivateDashboard;